export default "__VITE_ASSET__5fe75cef__"